import { render, staticRenderFns } from "./ListAllItems.vue?vue&type=template&id=ade9c806&scoped=true&lang=pug&"
import script from "./ListAllItems.vue?vue&type=script&lang=ts&"
export * from "./ListAllItems.vue?vue&type=script&lang=ts&"
import style0 from "./ListAllItems.vue?vue&type=style&index=0&id=ade9c806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade9c806",
  null
  
)

export default component.exports